import type { Button, ButtonVariant } from '../Button/Button';
import type { Image } from '../Image/Image';
import type { Block } from './Block';
import { isBlock } from './Block';

/**
 * Interface that represents a HeroBlock model.
 *
 * @interface
 * @extends {Block}
 */

export interface ContentBlock extends Block {
	text: string;
	image: Image | null;
	imageIsWide: boolean;
	mobileImageAlignment: 'top' | 'bottom';
	desktopImageAlignment: 'left' | 'right';
	button: Button | null;
	buttonAlignment: 'default' | 'center';
	buttonClass: ButtonVariant;
}

export function isContentBlock(block: any): block is ContentBlock {
	return isBlock(block) && block.type === 'content';
}
